import { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';

function SearchControl({ onLocationSelect }) {
    const map = useMap();

    useEffect(() => {
        const provider = new OpenStreetMapProvider();
        const searchControl = new GeoSearchControl({
            provider,
            style: 'bar',
            showMarker: false, // Kita pakai marker sendiri, jadi ini false
        });

        map.addControl(searchControl);

        map.on('geosearch/showlocation', (result) => {
            if (result?.location?.lat && result?.location?.lng) {
                onLocationSelect(result.location);
            } else {
                console.warn('Lokasi tidak valid. Pastikan memilih hasil dari pencarian.');
            }
        });

        return () => {
            map.removeControl(searchControl);
        };
    }, [map, onLocationSelect]);

    return null;
}

export default SearchControl;
